import React from 'react';
import styles from './PageHeader.module.css';

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({ eyebrow, title, subtitle, action }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerInner}>
        <div>
          {eyebrow && <div className={styles.eyebrow}>{eyebrow}</div>}
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
